module.exports = __webpack_public_path__ + "img/handyman.35176aa9.png";